import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { firestore } from '../lib/firebase/config';

export const useRoomPermissions = () => {
  const [permissions, setPermissions] = useState({
    canAssignPilgrims: false,
    canRemovePilgrims: false
  });

  useEffect(() => {
    const checkPermissions = async () => {
      const userRole = localStorage.getItem('userRole');
      const userId = localStorage.getItem('userId');

      if (!userId) return;

      // Admin has full permissions
      if (userRole === 'admin') {
        setPermissions({
          canAssignPilgrims: true,
          canRemovePilgrims: true
        });
        return;
      }

      // Guide and Organizer can manage pilgrims
      if (userRole === 'guide' || userRole === 'organizer') {
        setPermissions({
          canAssignPilgrims: true,
          canRemovePilgrims: true
        });
        return;
      }

      // Default: no permissions
      setPermissions({
        canAssignPilgrims: false,
        canRemovePilgrims: false
      });
    };

    checkPermissions();
  }, []);

  const canManageBed = async (bed: any) => {
    const userRole = localStorage.getItem('userRole');
    const userId = localStorage.getItem('userId');

    if (!userId || !bed.pilgrimId) return false;

    // Admin can manage all beds
    if (userRole === 'admin') return true;

    // Guide can only manage their own pilgrims
    if (userRole === 'guide') {
      return bed.guideId === userId;
    }

    // Organizer can manage pilgrims of their guides
    if (userRole === 'organizer') {
      try {
        // Get the guide's info to check if they belong to this organizer
        const guidesRef = collection(firestore, 'Guides');
        const q = query(guidesRef, where('organizerId', '==', userId));
        const snapshot = await getDocs(q);
        
        // Check if the bed's guide is one of the organizer's guides
        const organizerGuides = snapshot.docs.map(doc => doc.id);
        return organizerGuides.includes(bed.guideId);
      } catch (error) {
        console.error('Error checking organizer permissions:', error);
        return false;
      }
    }

    return false;
  };

  return { ...permissions, canManageBed };
};
